/**
 * Maximum number of remaining tickets to show indicator for timeslot
 */
export const REMAINING_TICKETS_LIMIT = 4;

/**
 * User ID length
 */
export const UID_LENGTH = 28;

/**
 * Landing page game ID
 */
export const LANDING_PAGE_GAME_ID = '2';

/**
 * Timeslot select cut-off time
 * In minutes
 * Until this number of minutes past the timeslot, display the timeslot
 */
export const TIMESLOT_SELECT_CUT_OFF_TIME = 10;
/**
 * Checkout cut-off time
 * In minutes
 * Until this number of minutes past the timeslot, checkout can be complete
 */
export const CHECKOUT_CUT_OFF_TIME = 15;

/**
 * Kombini names
 */
export const KOMBINIS = {
  'family-mart': 'Family Mart',
  //'seven-eleven': '7-Eleven',
  lawson: 'Lawson'
};

/**
 * Valid game IDs
 */
export const GAME_IDS = ['0', '1', '2', '3', '4', '6', '7', '8'];

/**
 * Game series
 */
export const GAME_SERIES = {
  '1': {
    0: {
      gameId: '2',
      label: '第1弾'
    },
    1: {
      gameId: '1',
      label: '第2弾'
    }
  },
  '2': {
    0: {
      gameId: '2',
      label: '第1弾'
    },
    1: {
      gameId: '1',
      label: '第2弾'
    }
  }
};

/**
 * Default colours
 */
export const DEFAULT_COLOURS = {
  primary: '#4C78BC',
  hue1: '#1771aa',
  startNextButtonLeft: '#269ac1',
  startNextButtonRight: '#1177ff',
  startNextButtonText: 'white',
  weekday: '#26A4BB',
  holiday: '#FF4642'
};

/**
 * Game primary colours
 */
export const GAME_TO_COLOURS = {
  // SHC1
  '0': {
    ...DEFAULT_COLOURS
  },
  // SHC2
  '1': {
    ...DEFAULT_COLOURS,
    primary: '#BB2821',
    hue1: '#F92B20',
    startNextButtonLeft: '#EA625B',
    startNextButtonRight: '#FC544B'
  },
  // SHC1 - Remake
  '2': {
    ...DEFAULT_COLOURS
  },
  // PSY
  '3': {
    ...DEFAULT_COLOURS,
    primary: '#44A8A8',
    hue1: '#44A8A8',
    startNextButtonLeft: '#30B9C6',
    startNextButtonRight: '#30B9C6',
    startNextButtonText: '#111111'
  },
  // Compass
  '6': {
    ...DEFAULT_COLOURS,
    primary: '#C1FE00'
  },
  '7': {
    ...DEFAULT_COLOURS,
    primary: '#C1FE00'
  },
  '8': {
    ...DEFAULT_COLOURS,
    primary: '#C1FE00'
  }
};

/**
 * WIFI details
 */
export const WIFI_IDS = {
  '0': 'Welcome-to-Pretia',
  '1': 'Welcome-to-Pretia',
  '2': 'Welcome-to-Pretia',
  '3': 'ENJOY-AR-GAME',
};
export const WIFI_PASSWORDS = {
  '0': 'fun-place-to-work',
  '1': 'fun-place-to-work',
  '2': 'fun-place-to-work',
  '3': 'lets-start'
};

/**
 * Social media
 */
export const TWITTER_HANDLE = '@arpuzzle';

/**
 * Location storage params
 */
// Booking key saved to local storage to prevent multiple players using one account
export const GAME_START_BOOKING_KEY = 'booking-id';

/**
 * Search parameters
 */
export const REDIRECT_PARAM = 'redirect';
export const GAME_ID = 'game';
// Checkout related
export const COUPON_ID = 'coupon';
export const TIMESLOT_ID = 'timeslot';
export const TICKETS_ID = 'tickets';
export const BOOKING_ID = 'booking';
export const BOOKING_REGISTRATION_SELECTED_PARAM = 'selected-id';
export const BOOKING_REGISTRATION_BOOKING_IDS_PARAM = 'id';
// Start code used for game start
export const GAME_START_CODE = 'start-code';
// Referal ID used to link orders for compensation etc
export const COUPON_REFERAL_CODE = 'referral-code';
export const MINIMUM_PERCENTAGE_COMPLETE_TO_SUCCESS = 50.0;
